import { memo, useState, type CSSProperties } from 'react';
import { numberGlyphs } from './numberGlyphs';

// Inherit the surrounding amount's typography, not broad label-span styles.
const typography: CSSProperties = {
  font: 'inherit',
  color: 'inherit',
  letterSpacing: 'inherit',
  fontVariantNumeric: 'tabular-nums',
};

export const AnimatedNumber = memo(function AnimatedNumber({
  value,
}: {
  value: string | number;
}) {
  const text =
    typeof value === 'number' && !Number.isFinite(value) ? '—' : String(value);
  const [frame, setFrame] = useState({ text, previous: null as string | null });
  if (frame.text !== text) setFrame({ text, previous: frame.text });
  if (!/\d/.test(text)) return <>{text}</>;
  return (
    <span className="animated-number" style={typography}>
      {/* Assistive technology and copied text always get the exact latest value. */}
      <span className="sr-only">{text}</span>
      <span className="number-visual" aria-hidden="true" style={typography}>
        {numberGlyphs(text, frame.previous).map((glyph) => (
          <span className="number-slot" key={glyph.key} style={typography}>
            <span
              className={
                'number-glyph' + (glyph.previous ? ' is-entering' : '')
              }
              key={glyph.character}
              style={typography}
            >
              {glyph.character}
            </span>
            {glyph.previous && (
              <span
                className="number-glyph is-leaving"
                key={'old-' + glyph.previous}
                style={typography}
              >
                {glyph.previous}
              </span>
            )}
          </span>
        ))}
      </span>
    </span>
  );
});
